const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    elements: `${API_URL}/padding-machines`,
    saveSpeedTable: `${API_URL}/padding-machine/save-speed-table`
};

export default apiUrls;
